<template>
    <div class="en_container">
        <!-- 顶部 -->
        <div class="head_top">
            <div class="center">
                <img src="../../assets/img/english2/logo_en.png" class="logo">
                <div class="language">
                    EN
                    /
                    <router-link to="/">CH</router-link>
                </div>
                <transition name="slide">
                    <ul class="menus" v-if="menuShow || clientWidth > 640">
                        <li>EARPHONES</li>
                        <li>BLUETOOTH</li>
                        <li>SUPPORT</li>
                    </ul>
                </transition>
                <button type="button" class="navbar-toggle" @click="menuShow = !menuShow">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            </div>
        </div>
        <!-- banner -->
        <div class="banner">
            <div class="center">
                <h1>NEW <br>BLUETOOTH 5.0</h1>
                <h2><img src="../../assets/img/english2/logo_en.png"> S1</h2>
                <H3>NEW BLUETOOTH 5.0 TECHNOLOGY <br>FOR FASTER TRANSMISSION</H3>
                <button class="coming_btn">COMING SOON</button>
            </div>
        </div>
        <!-- 主体内容 -->
        <div class="body" @click="menuShow = false">
            <div class="center">
                <h2>FIND YOUR EARPHONE</h2>
                <!-- 产品 -->
                <div class="box">
                    <div class="box_body">
                        <h3>WIRELESS BLUETOOTH</h3>
                        <p class="p1">MORE LIGHTER MORE POWERFUL</p>
                        <p class="p2"><img src="../../assets/img/english2/logo_black.png"> N1</p>
                        <img class="box_pro" src="../../assets/img/english2/img1.png" alt="TANGMAI N1">
                    </div>
                    
                    <div class="box_foot">
                        <button class="coming_btn">COMING SOON</button>
                    </div>
                </div>
                <div class="box">
                    <div class="box_body">
                        <h3>WIRED EARPHONE</h3>
                        <p class="p1">ACOUSTIC SAC 3.0</p>
                        <p class="p2"><img src="../../assets/img/english2/logo_black.png"> F50</p>
                        <img class="box_pro" src="../../assets/img/english2/img2.png" alt="TANGMAI F50">
                    </div>
                    
                    <div class="box_foot">
                        <button class="coming_btn">COMING SOON</button>
                    </div>
                </div>
                <div class="box">
                    <div class="box_body">
                        <h3>WIRED EARPHONE</h3>
                        <p class="p1">MORE FUN MORE COLORS</p>
                        <p class="p2"><img src="../../assets/img/english2/logo_black.png"> F10</p>
                        <img class="box_pro" src="../../assets/img/english2/img3.png" alt="TANGMAI F10">
                    </div>
                    
                    <div class="box_foot">
                        <button class="coming_btn">COMING SOON</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="foot">
            <div class="center">
                <img class="foot_logo" src="../../assets/img/english2/logo_blue.png"/>
                <ul class="foot_map">
                    <li>
                        <p class="p1">Products</p>
                        <p class="p2">Earphones</p>
                        <p class="p3">Bluetooth</p>
                    </li>
                    <li>
                        <p class="p1">Support</p>
                        <p class="p2">Service</p>
                        <p class="p3">Contact us</p>
                    </li>
                    <li>
                        <p class="p1">Follow Us</p>
                        <p class="p2">
                            <img src="../../assets/img/english2/f1.png">
                            <img src="../../assets/img/english2/f2.png">
                        </p>
                        <p class="p3"><img src="../../assets/img/english2/f3.png"></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            menuShow: false,
            clientWidth: 0
        }
    },
    beforeMount(){
        this.clientWidth = document.body.clientWidth;
        window.onresize = () => {
            this.clientWidth = document.body.clientWidth;
        }
    }
}
</script>


<style scoped>
@font-face
{
    font-family: pingfang;
    src: url('../../assets/fonts/pingfang.subset.ttf'); /* IE9+,可以是具体的实际链接 */
}
@font-face
{
    font-family: pingfang_b;
    src: url('../../assets/fonts/pingfang_b.subset.ttf'); /* IE9+,可以是具体的实际链接 */
}

*{
    font-family: pingfang, 微软雅黑;
}
.center{
    width: 1000px;
    margin: 0 auto;
}
.head_top{
    height: 96px;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0,0,0,0.5);
    color: #ffffff;
    z-index: 10;
}
.head_top .logo{
    margin-top: 42px;
}
.head_top .language{
    float: right;
    margin-top: 44px;
    color: #999999;
    margin-left: 20px;
}
.head_top .language a{
    color: #999999;
}
.head_top .menus{
    float: right;
    margin-top: 44px;
}

.head_top .menus li{
    float: right;
    margin: 0 25px;
}
.banner{
    height: 1090px;
    background: url(http://wx2.sinaimg.cn/large/0067mezugy1g291aon182j31hc0u0mzs.jpg) no-repeat center;
    background-size: cover;
    color: #ffffff;
    overflow: hidden;
}
.banner h1{
    margin-top: 380px;
    font-size: 34px;
    font-family: pingfang_b;
    font-weight: bold;
    line-height: 54px;
}
.banner h2{
    font-size: 20px;
    font-family: pingfang_b;
    font-weight: bold;
    margin-top: 20px;
}
.banner h2 img{
    height: 18px;
    margin-right: 10px;
    margin-top: -4px;
}
.banner h3{
    font-size: 15px;
    line-height: 34px;
    margin-top: 20px;
}
.banner button{
    margin-top: 104px;
}
.coming_btn{
    width: 128px;
    height: 38px;
    background: #0163ec;
    border-radius: 18px;
    border: none;
    font-size: 12px;
    color: #ffffff;
}
.body{
    background: #e3e3e3;
    margin-top: 20px;
    overflow: hidden;
}
.body h2{
    font-size: 32px;
    font-family: pingfang_b;
    font-weight: bold;
    margin-left: 78px;
    margin-top: 154px;
}
.box{
    width: 100%;
    float: left;
    margin-top: 134px;
}
.box:last-child{
    margin-bottom: 134px;
}
.box_body{
    background: #ffffff;
    padding-left: 77px;
    float: left;
    width: 100%;
    height: 386px;
    position: relative;
}
.box h3{
    margin-top: 114px;
    font-size: 28px;
    font-family: pingfang_b;
    font-weight: bold;
}
.box .p1{
    font-size: 16px;
    margin-top: 24px;
}
.box .p2{
    font-size: 20px;
    line-height: 18px;
    margin-top: 92px;
    font-family: pingfang_b;
    font-weight: bold;
}
.box .p2 img{
    height: 18px;
    vertical-align: middle;
    margin-top: -4px;
}
.box .box_pro{
    position: absolute;
    bottom: 0px;
    right: 236px;
    height: 336px;
}
.body .box:first-of-type .box_pro{
    top: -64px;
    right: 24px;
    height: 530px;
}
.box_foot{
    background: #efeff1;
    height: 102px;
    padding-left: 77px;
    float: left;
    width: 100%;
}
.box_foot button{
    margin-top: 24px;
}
.foot{
    padding-bottom: 30px;
    overflow: hidden;
}
.foot .foot_logo{
    float: left;
    margin-top: 90px;
    height: 18px;
}
.foot_map{
    float: right;
    margin-top: 90px;
}
.foot_map li{
    float: left;
    margin-left: 60px;
    margin-top: 0px;
}
.foot_map li .p1{
    font-size: 16px;
    font-weight: bold;
    font-family: pingfang_b;
}
.foot_map li .p2{
    margin-top: 58px;
    font-size: 14px;
    color: #999999;
}
.foot_map li .p3{
    margin-top: 30px;
    font-size: 14px;
    color: #999999;
}
.foot_map li .p2 img{
    margin-right: 20px;
}

@media screen and (max-width: 640px){
    .center{
        width: 100%;
        padding: 0 20px;
    }
    .head_top{
        height: 54px;
        text-align: center;
    }
    .head_top .logo{
        margin-top: 20px;
        height: 14px;
    }
    .head_top .language{
        margin-top: 18px;
        font-size: 14px;
    }
    .head_top .menus{
        /* display: none; */
        background: rgba(0,0,0,0.5);
        position: absolute;
        left: 0px;
        width: 100%;
        top: 6px;
    }
    .head_top .menus li{
        width: 100%;
        padding: 20px;
        margin: 0;
        text-align: left;
    }
    .navbar-toggle{
        float: left;
    }
    .navbar-toggle .icon-bar{
        background: #ffffff;
    }
    .banner{
        height: 540px;
    }
    .banner h1{
        margin-top: 100px;
        font-size: 20px;
        line-height: 30px;
    }
    .banner h2{
        font-size: 16px;
        margin-top: 30px;
    }
    .banner h2 img{
        height: 14px;
    }
    .banner h3{
        font-size: 12px;
        line-height: 18px;
        margin-top: 20px;
    }
    .banner button{
        margin-top: 190px;
    }
    .body{
        margin-top: 10px;
    }
    .body h2{
        font-size: 22px;
        margin-left: 0px;
        margin-top: 60px;
    }
    .box{
        margin-top: 30px;
    }
    .box_body{
        padding-left: 20px;
        height: auto;
    }
    .box h3{
        margin-top: 30px;
        font-size: 18px;
    }
    .box .p1{
        font-size: 14px;
        margin-top: 10px;
    }
    .box .p2{
        font-size: 16px;
        margin-top: 20px;
    }
    .box .p2 img{
        height: 14px;
    }
    .box .box_pro, .body .box:first-of-type .box_pro{
        position: relative;
        width: 60%;
        height: auto;
        top: 0px;
        left: 0px;
        right: 0px;
        margin-top: 30px;
        float: right;
        margin-right: 20px;
    }
    .body .box:first-of-type .box_pro{
        width: 80%;
     }
    .box_foot{
        padding-left: 20px;
        height: 84px;
    }
    .foot .foot_logo{
        margin-top: 40px;
        height: 16px;
    }
    .foot_map{
        margin-top: 30px;
        float: left;
    }
    .foot_map li{
        margin-left: 0px;
        margin-right: 20px;
    }
    .foot_map li .p1{
        font-size: 14px;
    }
    .foot_map li .p2{
        margin-top: 20px;
        font-size: 12px;
    }
    .foot_map li .p3{
        margin-top: 20px;
        font-size: 12px;
    }
    .foot_map li .p2 img{
        height: 24px;
        margin-right: 10px;
    }
    .foot_map li .p3 img{
        height: 18px;
    }
    .box:last-child{
        margin-bottom: 30px;
    }

    .slide-enter-active, .slide-leave-active {
        transition: .5s;
        height: 184px;
    }
    .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
        height: 0px;
        opacity: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/english/index2.vue